export enum SectionsPersonalAccount {
  Profile = 'profile',
  Orders = 'orders',
  Purchases = 'purchases',
  Records = 'records',
  Discount = 'discount',
  Guaranty = 'guaranty',
  Storage = 'storage',
  Auto = 'auto',
  Support = 'support',
  Setting = 'setting',
}
